import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import {
  getTicketsForMassivePostpone,
  clearTickets,
  postTicketMassivePostpone,
  postMassiveTicketActionModal,
  postImmediateTicketPostpone,
  clearItinerary,
  getItineraryForCounter,
} from '../../../../actions';
import {
  DEFAULT_QUERY,
  DEFAULT_QUERY_GET_ALL,
} from '../../../../config/queries';
import TicketMassivePostponeSearchResultForm from './TicketMassivePostponeSearchResultForm';
import { TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS } from '../../../../config/constants';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import Table from '../../../common/Table';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import DateCell from '../../../common/cells/DateCell';
import TicketMassivePostponeSearchForm from './TicketMassivePostponeSearchForm';

export const TicketMassivePostponeSearch = ({
  dispatchClearTickets,
  dispatchGetTicketsForMassivePostpone,
  dispatchPostMassiveTicketActionModal,
  dispatchPostImmediateTicketPostpone,
  dispatchChange,
  ticketList,
  dispatchPostTicketMassivePostpone,
  dispatchClearItinerary,
  dispatchGetItineraryForCounter,
}) => {
  const [loading, setLoading] = useState(false);
  const [isImmediate, setIsImmediate] = useState(null);
  const [body, setBody] = useState(null);
  const [comment, setComment] = useState(null);
  const [endpoint, setEndpoint] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [ticketIdList, setTicketIdList] = useState([]);
  const [formKey, setFormKey] = useState(0);
  const [itinerary, setItinerary] = useState(null);

  useEffect(() => () => dispatchClearTickets(), []);

  const onSearchTickets = () => {
    if (isImmediate === null) {
      toastr.warning('Debe seleccionar el tipo de postergación');
      return;
    }

    const newFormValues = {
      itineraryId: itinerary,
      ...DEFAULT_QUERY,
      size: DEFAULT_QUERY_GET_ALL.size,
      isImmediate,
    };

    dispatchClearTickets();
    dispatchGetTicketsForMassivePostpone(newFormValues);
  };

  const generateBody = (modalMessage, ticketTableList) => (
    <>
      <p>{modalMessage}</p>
      <hr />
      <p>Boletos seleccionados:</p>
      <Table
        columns={[
          {
            Header: 'Serie',
            accessor: 'documentSeries',
            className: 'text-center',
            width: 100,
          },
          {
            Header: 'Correlativo',
            accessor: 'documentCode',
            className: 'text-center',
            width: 100,
          },
          {
            Header: 'Origen',
            accessor: 'sourceLocation.name',
            className: 'text-center',
          },
          {
            Header: 'Fecha de Viaje',
            accessor: 'departureDate',
            className: 'text-center',
            Cell: (row) => (
              <DateCell value={row.value} format={DATE_TIME_FORMAT} />
            ),
          },
          {
            Header: 'Destino',
            accessor: 'destinationLocation.name',
            className: 'text-center',
          },
          {
            Header: 'Cliente',
            accessor: 'customer.fullName',
            className: 'text-center',
          },
        ]}
        data={ticketTableList}
        manual={false}
      />
    </>
  );

  const handleMassivePostpone = async (formValues) => {
    const response = await dispatchPostMassiveTicketActionModal(formValues);
    if ((response && response.message, response.url)) {
      dispatchChange('TicketMassivePostponeSearchResultForm', 'comment', '');
      setEndpoint(response.url);
      setBody(generateBody(response.message, response.ticketList));
      setShowConfirmationModal(true);
    }
    setLoading(true);
  };

  const showMessageConfirmation = (formTicketIdList) => {
    const selectedTicketList = ticketList.filter((ticket) =>
      formTicketIdList.includes(ticket.id),
    );
    setShowConfirmationModal(true);
    setBody(
      generateBody(
        '¿Está seguro de que desea postergar los siguientes boletos?',
        selectedTicketList,
      ),
    );
  };

  const onSubmit = async (formValues) => {
    const newFormValues = {
      comment: formValues.comment,
      ticketIdList: formValues.items,
    };
    setComment(formValues.comment);
    setTicketIdList(newFormValues.ticketIdList);

    if (isImmediate) {
      await handleMassivePostpone(newFormValues);
    } else {
      showMessageConfirmation(newFormValues.ticketIdList);
    }
  };

  const handleTypeChange = ({ value }) => {
    setIsImmediate(
      value === TICKET_MASSIVE_POSTPONE_TYPE_OPTIONS.IMMEDIATE.value,
    );
    setFormKey((prevKey) => prevKey + 1);
    dispatchClearTickets();
  };

  const clearState = () => {
    setTicketIdList([]);
    setShowConfirmationModal(false);
    setEndpoint(null);
    setBody(null);
    setLoading(false);
  };

  const handlePostponeTicket = async () => {
    dispatchClearTickets();
    setFormKey((prevKey) => prevKey + 1);

    if (isImmediate) {
      await dispatchPostImmediateTicketPostpone({
        endpoint,
        comment,
        ticketIdList,
      });
    } else {
      await dispatchPostTicketMassivePostpone({ comment, ticketIdList });
    }

    clearState();
  };

  const handleCloseModal = () => {
    clearState();
  };

  const handleSelectItinerary = ({ itineraryId }) => {
    setItinerary(itineraryId);
    dispatchGetItineraryForCounter(itineraryId);
  };
  const handleClear = () => {
    setItinerary(null);
    dispatchClearItinerary();
  };

  const handleShowItinerarySearch = () => {
    handleClear();
    dispatchChange('ManifestForm', 'itineraryId', '');
    dispatchChange('ManifestForm', 'itinerary', '');
  };

  return (
    <div>
      <TicketMassivePostponeSearchForm
        onSubmit={onSearchTickets}
        handleSelectItinerary={handleSelectItinerary}
        handleShowItinerarySearch={handleShowItinerarySearch}
        handleClear={handleClear}
        handleTypeChange={handleTypeChange}
      />

      <TicketMassivePostponeSearchResultForm
        key={formKey}
        onSubmit={onSubmit}
        disableButton={loading}
      />
      <ConfirmationModal
        show={showConfirmationModal}
        title="Confirmación de Postergación"
        body={body}
        onClickConfirm={handlePostponeTicket}
        onClickCancel={handleCloseModal}
        cancelButtonColor="primary"
        size="xl"
      />
    </div>
  );
};

TicketMassivePostponeSearch.propTypes = {
  dispatchGetTicketsForMassivePostpone: PropTypes.func.isRequired,
  dispatchClearTickets: PropTypes.func.isRequired,
  dispatchPostTicketMassivePostpone: PropTypes.func.isRequired,
  dispatchPostImmediateTicketPostpone: PropTypes.func.isRequired,
  dispatchPostMassiveTicketActionModal: PropTypes.func.isRequired,
  dispatchClearItinerary: PropTypes.func.isRequired,
  dispatchGetItineraryForCounter: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,

  ticketList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      documentSeries: PropTypes.string,
      documentCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      departureDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      sourceLocation: PropTypes.shape({ name: PropTypes.string }),
      destinationLocation: PropTypes.shape({ name: PropTypes.string }),
      customer: PropTypes.shape({ fullName: PropTypes.string }),
    }),
  ),
};

TicketMassivePostponeSearch.defaultProps = {
  ticketList: [],
};

const mapStateToProps = ({ ReservationUnit, ItineraryUnit }) => ({
  ticketList: ReservationUnit.Ticket.getIn(['all', 'content', 'content']),
  itineraryCounter:
    ItineraryUnit.Itinerary.getIn(['current', 'content']) || undefined,
});

TicketMassivePostponeSearch.defaultProps = {
  ticketList: [],
};

const mapDispatchToProps = {
  dispatchChange: change,
  dispatchGetTicketsForMassivePostpone: getTicketsForMassivePostpone,
  dispatchClearTickets: clearTickets,
  dispatchPostTicketMassivePostpone: postTicketMassivePostpone,
  dispatchPostMassiveTicketActionModal: postMassiveTicketActionModal,
  dispatchPostImmediateTicketPostpone: postImmediateTicketPostpone,
  dispatchClearItinerary: clearItinerary,
  dispatchGetItineraryForCounter: getItineraryForCounter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketMassivePostponeSearch);
